import React from 'react';
import _ from 'lodash';

import Form from '../../../../gd-form/form/form-modal/form-modal.jsx';
import FormError from '../../../../gd-form/common/form-error/form-error.tsx';
import FormManager from '../../../../gd-form/common/form-manager';
import ButtonSubmitDeprecated from 'core/gd-form/common/btn-submit/btn-submit';
import FormSelect from 'core/gd-form/form-element/select-new/select-new';

import SettingsFormProto from '../../settings-form-proto';

const sizeOptions = [
    {label:'2 Lines', value: 2},
    {label:'3 Lines', value: 3},
    {label:'4 Lines', value: 4},
    {label:'5 Lines', value: 5},
    {label:'6 Lines', value: 6},
    {label:'8 Lines', value: 8},
    {label:'10 Lines', value: 10},
    {label:'12 Lines', value: 12},
];

class StringSettingsForm extends SettingsFormProto {

    constructor(props) {
        super(props);

        // ad size field
        this.initFormData.size = _.get(this.props.field, 'params.size', 4);
        this.formStructure.fields.size = {
            type: 'select',
            isRequired: true,
            label: 'Size',
            onUserChange: () => this.setState({reRender: true})
        };


        this.form = new FormManager(this.formStructure, this.initFormData);
    }

    onSubmit(result) {

        result.type = gd.const.customFields.type.STRING;

        const field = this.props.field;
        field.label = result.name.trim();
        field.description = result.description;
        field.isRequired = result.isRequired;
        field.params = {
            size: result.size
        };

        this.props.onSubmit(field);
    }

    render() {
        return (
            <div className="form-container">
                {this.renderForm()}
                <div className="modal-submit">
                    <ButtonSubmitDeprecated form={this.form} className="submit" label="Submit" />
                </div>
            </div>
        );
    }

    renderForm() {

        return (
            <Form form={this.form} className="create-new-custom-field-form main" submitButton={false}>

                {this.renderType()}
                {this.renderName()}
                {this.renderDescription()}
                {this.renderIsRequired()}

                <div className="row cf">
                    <div className="label">Max Size</div>
                    <div className="element">
                        <FormSelect form={this.form}
                                name="size"
                                size="big"
                                options={sizeOptions}
                                placeholder="Size" />
                    </div>
                    <div className="cf" />
                    <FormError form={this.form} name="name" />
                </div>


                <div className="row cf preview-row">
                    <div className="label">Preview</div>
                    <div className="element">

                        <div className="gd-field-string preview">
                            <div className="value">Lorem ipsum</div>
                        </div>

                    </div>
                    <div className="cf" />
                </div>

            </Form>
        );
    }
}



export default function renderStringFormFieldFormElement(field, props) {
    return <StringSettingsForm field={field} {...props} />;
}
